import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Signup1() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    const user = {
      email,
      name,
      phone: phoneNumber,
    };
    const userString = JSON.stringify(user);
    localStorage.setItem("user", userString);
    navigate("/signup2");
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">Welcome Back</h1>
        <form onSubmit={handleLogin}>
          <label>Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter your full name"
            required
          />
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />

          <label>Phone number</label>
          <input
            type="tell"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="Enter your Phone number"
            required
          />

          <button type="submit">Continue</button>
        </form>
        <p className="signup-text">
          Already have an account? <span onClick={()=>navigate("/login")}>Login</span>
        </p>
      </div>
    </div>
  );
}
